import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2-al': {
			// ?safe&mock-data&country=US&area=activity-female-tai-chi-walking-v2-al&exp=web_welcome_for_applovin_tai_chi_walking~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_welcome_for_applovin_tai_chi_walking'),
			},
		},
	},
]

export default config
